/* PDP mobile v2 — behaviour that Liquid can't do. Runs only when the product section has .pdpm; (1) at every width, the rest ≤749 px.
   1) "Select size" state until the shopper taps a size (no preselected size)
   2) Gallery: next photo peeks (1.19 slides), counter placed on the active photo, one nudge on first visit
   3) Dock text mirrors the state (colour only until a size is chosen) */
// Desktop / tablet (Cristóbal, 2026-10-19): the model's height and size on each photo of the grid, as on phones.
// Same source: "Model is …" in the photo's alt text, else "Woman"/"Man" in it takes the section's caption.
(() => {
  const root = document.querySelector('.pdpm');
  if (!root) return;
  const captionFor = (img) => {
    const alt = img?.getAttribute('alt') || '';
    const own = alt.match(/model is[^|·]*(?:·[^|]*)?/i);
    if (own) return own[0].trim().replace(/^m/, 'M');
    if (/\bwoman\b/i.test(alt)) return root.dataset.modelWoman || '';
    if (/\bman\b/i.test(alt)) return root.dataset.modelMan || '';
    return '';
  };
  const ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="4" fill="none" stroke="currentColor" stroke-width="2"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const paint = () => {
    // Grid photos (≥1200 px) and the one-photo slider (750–1199 px); hidden on phones, which have the line instead
    root.querySelectorAll('gallery-section :is(.wt-masonry__slide, .swiper-slide)').forEach((slide) => {
      const text = captionFor(slide.querySelector('img'));
      let cap = slide.querySelector(':scope > .pdpm-dcap');
      if (!text) { cap?.remove(); return; }
      if (!cap) { cap = document.createElement('span'); cap.className = 'pdpm-dcap'; cap.innerHTML = ICON + '<span></span>'; slide.appendChild(cap); }
      const span = cap.querySelector('span');
      if (span.textContent !== text) span.textContent = text;
    });
  };
  paint();
  let queued = false;
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; paint(); }); } };
  const gal = root.querySelector('gallery-section');
  // A colour change re-renders the gallery: paint again (only reacts to added nodes, not to its own captions)
  new MutationObserver((list) => { if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && !n.classList?.contains('pdpm-dcap')))) queue(); })
    .observe(gal?.parentElement || root, { childList: true, subtree: true });
})();

// SWYTCH opens with a size selected (Alexander, 2026-10-20: "siempre tiene que venir con un talle seleccionado", L).
// The theme's first variant is S; without ?variant= in the link, L is selected on load. An out-of-stock L then shows
// the next-shipment card. Section setting "Size selected on landing (SWYTCH)" (data-default-size); empty = off.
(() => {
  const root = document.querySelector('.pdpm');
  const want = (root?.dataset.defaultSize || '').trim().toLowerCase();
  if (!want || new URLSearchParams(location.search).has('variant')) return;
  const input = [...root.querySelectorAll('.wt-product__option__body--tiles input[type="radio"]')].find((i) => i.value.trim().toLowerCase() === want);
  if (!input || input.checked) return;
  // The S card/chip would flash for a moment while the theme re-renders the variant: hidden until it has
  root.classList.add('pdpm--defaulting');
  const done = () => root.classList.remove('pdpm--defaulting');
  setTimeout(done, 2500);
  const go = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const off = subscribe(PUB_SUB_EVENTS.variantChange, () => { requestAnimationFrame(done); if (typeof off === 'function') off(); });
    }
    const label = input.nextElementSibling;
    if (label && label.tagName === 'LABEL') label.click();
    else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  };
  if (window.customElements && !customElements.get('variant-options')) customElements.whenDefined('variant-options').then(go);
  else go();
})();

// 1) "Select size" until the shopper picks a size. Off since 2026-10-20 (a size always comes selected); the
// section element needs data-ask-size="true" to bring it back.
(() => {
  const root = document.querySelector('.pdpm');
  if (!root || root.dataset.askSize !== 'true') return;

  const sectionId = root.dataset.sectionId;
  const form = document.getElementById(`product-form-${sectionId}`);
  const mainBtn = form?.querySelector('[name="add"]');
  const sizeInputs = () => [...root.querySelectorAll('.wt-product__option__body--tiles input[type="radio"]')];
  const sizeOption = () => root.querySelector('.wt-product__option__body--tiles')?.closest('.wt-product__option');
  const SELECT = root.dataset.selectLabel || 'Select size';

  // ---------- 1. Size not chosen yet ----------
  let chosen = new URLSearchParams(location.search).has('variant') || sizeInputs().length === 0;
  const colourName = () => root.querySelector('.wt-color-label .value')?.textContent.trim() || '';

  const paint = () => {
    root.classList.toggle('pdpm--nosize', !chosen);
    const val = sizeOption()?.querySelector('.wt-product__option__title .value');
    // "Size:" with nothing after the colon reads broken while no size is chosen
    const lbl = val?.parentElement;
    if (lbl && !lbl.dataset.pdpmText) {
      const first = [...lbl.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
      if (first) { lbl.dataset.pdpmText = first.textContent; lbl._pdpmNode = first; }
    }
    if (lbl && lbl._pdpmNode) {
      const want = chosen ? lbl.dataset.pdpmText : lbl.dataset.pdpmText.replace(/:\s*$/, ' ');
      if (lbl._pdpmNode.textContent !== want) lbl._pdpmNode.textContent = want; // only write on change: the MutationObserver watches this node
    }
    if (val) {
      if (!chosen) { if (val.textContent) val.dataset.pdpmSize = val.textContent; val.textContent = ''; }
      else if (!val.textContent && val.dataset.pdpmSize) val.textContent = val.dataset.pdpmSize;
    }
    const spans = [mainBtn?.querySelector('span'), document.querySelector('sticky-buy-button .wt-product__sticky-buy__button span')];
    const btns = [mainBtn, document.querySelector('sticky-buy-button .wt-product__sticky-buy__button')];
    btns.forEach((b) => b && b.classList.toggle('pdpm-select-btn', !chosen && !b.disabled));
    if (!chosen) spans.forEach((s) => { if (s && !s.closest('button')?.disabled && s.textContent.trim() !== SELECT) s.textContent = SELECT; });
    const v = document.querySelector('sticky-buy-button .wt-product__sticky-buy__variant');
    if (v && !chosen && v.textContent !== colourName()) v.textContent = colourName();
  };

  const restoreLabel = () => {
    const batch = document.getElementById(`ShipmentBatch-${sectionId}`)?.dataset.atcLabel;
    const label = batch || window.variantStrings?.addToCart || 'Add to cart';
    [mainBtn, document.querySelector('sticky-buy-button .wt-product__sticky-buy__button')].forEach((b) => {
      const s = b?.querySelector('span');
      if (b && s && !b.disabled && s.textContent.trim() === SELECT) s.textContent = label;
      b?.classList.remove('pdpm-select-btn');
    });
  };

  const choose = () => { if (chosen) return; chosen = true; restoreLabel(); paint(); };
  root.addEventListener('click', (e) => {
    if (e.target.closest('.wt-product__option__body--tiles .f-button__list__item')) choose();
  });
  root.addEventListener('change', (e) => {
    if (e.target.matches('.wt-product__option__body--tiles input[type="radio"]')) choose();
  });

  const askForSize = () => {
    const opt = sizeOption();
    const box = opt?.querySelector('.product-form__input');
    // Back to the first screen (photos, colours, sizes and button all fit there), not the sizes centred with the
    // photos cut in half. Only where the button doesn't fit (very short screens) stop just low enough to show it.
    const btn = form?.querySelector('[name="add"]');
    let top = 0;
    if (btn) top = Math.max(0, Math.round(btn.getBoundingClientRect().bottom + window.scrollY - window.innerHeight + 8));
    window.scrollTo({ top, behavior: 'smooth' });
    if (box) {
      box.classList.remove('pdpm-flash');
      const flash = () => { void box.offsetWidth; box.classList.add('pdpm-flash'); };
      // Flash once the page has arrived, so the shopper sees it
      let waited = 0;
      const tick = () => { waited += 50; if (Math.abs(window.scrollY - top) < 2 || waited > 1200) flash(); else setTimeout(tick, 50); };
      setTimeout(tick, 50);
    }
  };
  document.addEventListener('click', (e) => {
    if (chosen) return;
    const hit = e.target.closest(`#product-form-${CSS.escape(sectionId)} [name="add"], sticky-buy-button .wt-product__sticky-buy__button`);
    if (!hit) return;
    e.preventDefault(); e.stopImmediatePropagation();
    askForSize();
  }, true);

  // Variant changes re-render the button, the sticky card and the status line: repaint after each.
  let painting = false;
  const safePaint = () => { if (painting) return; painting = true; try { paint(); } finally { painting = false; } };
  const mo = new MutationObserver(() => { if (!chosen) requestAnimationFrame(safePaint); });
  [form, document.querySelector('sticky-buy-button'), sizeOption()].forEach((n) => n && mo.observe(n, { subtree: true, childList: true, characterData: true }));
  paint();
})();

// 2–3) Phones only (≤749 px): first-screen fit, buy bar pinned to the visual viewport, gallery and zoom
(() => {
  const root = document.querySelector('.pdpm');
  if (!root || !window.matchMedia('(max-width: 749px)').matches) return;
  const form = document.getElementById(`product-form-${root.dataset.sectionId}`);
  // The photo height (below) only changes while the shopper is at the top of the page: changing it further down
  // shifts everything under the photos. On iOS each slide of Safari's toolbar fires a resize, so refitting then made
  // the page and the buy bar twitch while scrolling (2026-10-30).
  const atTop = () => window.scrollY < 40;

  // Shopify's preview bar (theme previews only) covers the bottom of the screen: the photo height leaves room for it
  // so the preview shows what the live store shows above it. In the live store there is no bar and this is 0.
  const pbar = () => {
    // Only the part of the bar that is really on screen counts: once it is hidden ("Hide bar") it may still be in
    // the page but off screen or invisible, and then it must not take room from the photos.
    const el = document.getElementById('PBarNextFrameWrapper');
    if (!atTop()) return el;
    let h = 0;
    if (el) {
      const cs = getComputedStyle(el), r = el.getBoundingClientRect(), vh = window.innerHeight;
      const visible = cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0.05 && r.height > 0;
      if (visible && r.top < vh - 1) h = Math.max(0, Math.round(Math.min(vh, r.bottom) - Math.max(0, r.top)));
    }
    const v = `${h}px`;
    if (document.documentElement.style.getPropertyValue('--pdpm-pbar') !== v) document.documentElement.style.setProperty('--pdpm-pbar', v);
    return el;
  };
  [0, 800, 2000, 4000].forEach((t) => setTimeout(() => {
    const el = pbar();
    if (el && !el._pdpm && window.ResizeObserver) { el._pdpm = true; new ResizeObserver(pbar).observe(el); }
  }, t));

  // The photos take whatever height is left so the buy button ends inside the first screen. What sits above and
  // below them changes per product (the "Free gift" bar shows on products under $199, a title can wrap), so it is
  // measured: everything from the top of the page to the bottom of the button, minus the photos, plus 8 px of air.
  const fitFirstScreen = () => {
    if (window.innerWidth >= 750 || !atTop()) return;
    // With "Buy more, save more" in place of the picker (assets/crew-offer.js, layout "top") its button stands in for
    // the theme's (in layout "below" the theme's own button stays). Measured only in
    // its first state (one suit, both cards showing): the builder opening below must not shrink the photos above.
    const crew = document.documentElement.classList.contains('crew-on') && root.querySelector('crew-builder:not([data-layout="below"])');
    if (crew && (crew.querySelector('.crew__builder:not([hidden])') || !crew.querySelector('.crew__choice'))) return;
    const btn = crew ? crew.querySelector('.crew__atc') : form?.querySelector('[name="add"]');
    const photos = root.querySelector('gallery-section .swiper-wrapper');
    if (!btn || !photos || !btn.offsetHeight) return;
    const stack = Math.round(btn.getBoundingClientRect().bottom + window.scrollY - photos.getBoundingClientRect().height + 8);
    const cur = parseFloat(root.style.getPropertyValue('--pdpm-stack')) || 0;
    if (stack > 200 && Math.abs(stack - cur) > 1) root.style.setProperty('--pdpm-stack', `${stack}px`);
    // Even with the photos at their 164 px floor the button would end below the first screen (very short screens,
    // like an iPhone with Display Zoom): the announcement bar above the header goes away on this page so it fits.
    const html = document.documentElement;
    const bar = document.querySelector('.wt-announcement-bar');
    if (bar && stack > 200 && !html.classList.contains('pdpm-short') && bar.offsetHeight) {
      const pb = parseFloat(html.style.getPropertyValue('--pdpm-pbar')) || 0;
      if (stack + 164 + pb > window.innerHeight - 4) {
        html.classList.add('pdpm-short');
        shortAtWidth = window.innerWidth;
        requestAnimationFrame(fitFirstScreen);
      }
    }
  };
  // A new width (the phone turned) decides again whether the announcement bar fits.
  let shortAtWidth = 0;
  window.addEventListener('resize', () => {
    if (shortAtWidth && window.innerWidth !== shortAtWidth) {
      shortAtWidth = 0;
      document.documentElement.classList.remove('pdpm-short');
    }
  });
  [0, 400, 1200, 2500, 5000].forEach((t) => setTimeout(fitFirstScreen, t));
  window.addEventListener('resize', () => requestAnimationFrame(fitFirstScreen));
  if (document.fonts?.ready) document.fonts.ready.then(fitFirstScreen);

  // Buy bar: flush with the bottom of what the shopper sees. Normally that's plain CSS (bottom: 0), which follows iOS
  // Safari's toolbar as it slides in and out. Re-pinning it on every scroll frame made it jump and lag behind the
  // toolbar (2026-10-30), so it's only pinned to the visual viewport when zoomed in or with the keyboard up for a
  // text field. Other signals (the visual viewport's offset or height) also flip for a moment while the toolbar
  // slides or the page bounces at its ends, which switched the bar between the two positions mid-scroll.
  const typing = () => !!document.activeElement?.matches?.('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, [contenteditable="true"]');
  const dock = document.querySelector('sticky-buy-button');
  const vv = window.visualViewport;
  const pinDock = () => {
    if (!dock || !vv) return;
    const offset = window.innerWidth < 750 && (vv.scale > 1.01 || (typing() && window.innerHeight - vv.height > 1));
    if (!offset) {
      if (dock.style.top) { dock.style.removeProperty('top'); dock.style.removeProperty('bottom'); }
      return;
    }
    const top = Math.round(vv.offsetTop + vv.height - dock.offsetHeight);
    if (dock.style.top !== `${top}px`) { dock.style.top = `${top}px`; dock.style.bottom = 'auto'; }
  };
  let pinQueued = false;
  const queuePin = () => { if (pinQueued) return; pinQueued = true; requestAnimationFrame(() => { pinQueued = false; pinDock(); }); };
  if (vv) { vv.addEventListener('resize', queuePin); vv.addEventListener('scroll', queuePin); }
  window.addEventListener('scroll', queuePin, { passive: true });
  window.addEventListener('resize', queuePin);
  document.addEventListener('focusin', queuePin);
  document.addEventListener('focusout', queuePin);
  if (dock && window.ResizeObserver) new ResizeObserver(queuePin).observe(dock);
  [0, 500, 1500].forEach((t) => setTimeout(queuePin, t));

  // ---------- 2. Gallery ----------
  // Idempotent: safe to call any time (first load, photo loads, colour change re-renders the gallery).
  const galleryEl = () => root.querySelector('gallery-section');
  const captionFor = (img) => {
    const alt = img?.getAttribute('alt') || '';
    const own = alt.match(/model is[^|·]*(?:·[^|]*)?/i);
    if (own) return own[0].trim().replace(/^m/, 'M');
    if (/\bwoman\b/i.test(alt)) return root.dataset.modelWoman || '';
    if (/\bman\b/i.test(alt)) return root.dataset.modelMan || '';
    return '';
  };
  const refreshGallery = () => {
    const gallery = galleryEl();
    const sw = gallery?.gallerySwiper;
    if (!sw || sw.destroyed) return false;
    // Real photo ratio per slide (variant images are declared 1100×1100, which would leave an empty band)
    let changed = false;
    gallery.querySelectorAll('.swiper-slide').forEach((slide) => {
      const img = slide.querySelector('img');
      if (!img || !img.naturalWidth) return;
      const r = (img.naturalWidth / img.naturalHeight).toFixed(4);
      if (slide.style.getPropertyValue('--slide-ratio').trim() !== r) { slide.style.setProperty('--slide-ratio', r); changed = true; }
    });
    if (sw.params.slidesPerView !== 'auto' || sw.params.autoHeight) {
      sw.params.slidesPerView = 'auto'; sw.params.spaceBetween = 8; sw.params.autoHeight = false; changed = true;
    }
    // No empty room after the last photo: when the last two fit side by side, the end shows both
    if (sw.params.slidesOffsetAfter) { sw.params.slidesOffsetAfter = 0; changed = true; }
    if (changed) sw.update();
    // Counter sits on the active photo; caption follows the active photo's model
    const active = sw.slides[sw.activeIndex] || gallery.querySelector('.swiper-slide');
    if (active) gallery.style.setProperty('--pdpm-slide-w', `${active.getBoundingClientRect().width}px`);
    const host = gallery.querySelector('[data-gallery]') || gallery;
    // Own counter on the current photo ("n / total"): the theme's counts swipe positions, which is one less
    // than the photos when the last two fit side by side
    let count = host.querySelector('.pdpm-count');
    if (!count) { count = document.createElement('span'); count.className = 'pdpm-count'; count.setAttribute('aria-hidden', 'true'); host.appendChild(count); }
    const atEnd = sw.isEnd && !sw.isBeginning;
    const countText = `${atEnd ? sw.slides.length : sw.activeIndex + 1} / ${sw.slides.length}`;
    if (count.textContent !== countText) count.textContent = countText;
    count.hidden = sw.slides.length < 2;
    // Segmented bar: one segment per photo of the selected colour, the current one filled; tap to jump
    const slides = [...sw.slides];
    let segs = gallery.querySelector('.pdpm-segs');
    if (!segs) {
      segs = document.createElement('div'); segs.className = 'pdpm-segs';
      segs.addEventListener('click', (e) => {
        const b = e.target.closest('button[data-i]');
        const s = galleryEl()?.gallerySwiper;
        if (b && s) s.slideTo(+b.dataset.i);
      });
      host.after(segs);
    }
    if (segs.childElementCount !== slides.length) {
      segs.innerHTML = slides.map((_, i) => `<button type="button" data-i="${i}" aria-label="Photo ${i + 1} of ${slides.length}"></button>`).join('');
    }
    // At the end every photo still on screen is lit (the last two can share the screen)
    [...segs.children].forEach((b, i) => b.classList.toggle('is-on', i === sw.activeIndex || (atEnd && i > sw.activeIndex)));
    segs.hidden = slides.length < 2;

    // Model line under the photos: who is in the active photo (height · size). Photos without a model keep the
    // line's space (no jump while swiping) but show nothing.
    let line = gallery.querySelector('.pdpm-modelline');
    if (!line) {
      line = document.createElement('p'); line.className = 'pdpm-modelline';
      line.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="4" fill="none" stroke="currentColor" stroke-width="2"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span></span>';
      segs.after(line);
    }
    const text = captionFor(active?.querySelector('img'));
    const span = line.querySelector('span');
    if (span.textContent !== text) span.textContent = text;
    line.classList.toggle('is-empty', !text);

    if (!sw._pdpm) {
      sw._pdpm = true;
      ['slideChange', 'resize', 'update', 'reachEnd', 'fromEdge', 'transitionEnd'].forEach((ev) => sw.on(ev, () => requestAnimationFrame(refreshGallery)));
    }
    return true;
  };
  const waitGallery = (tries = 0) => { if (!refreshGallery() && tries < 40) setTimeout(() => waitGallery(tries + 1), 150); };
  waitGallery();
  // A photo finishing loading may change its ratio
  root.addEventListener('load', (e) => { if (e.target.tagName === 'IMG' && e.target.closest('gallery-section')) requestAnimationFrame(refreshGallery); }, true);
  // Colour change re-renders the gallery: refresh a few times while it settles
  const afterColour = () => [80, 400, 1000, 2000].forEach((t) => setTimeout(() => { waitGallery(); fitFirstScreen(); }, t));
  root.addEventListener('change', (e) => { if (e.target.closest('.wt-product__option__body--thumbs')) afterColour(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, afterColour);

  // ---------- 3. Zoom (PhotoSwipe) ----------
  // No zoom button: tapping the photo opens it full screen. On phones the photo fills the screen's height
  // under the top bar, double tap / pinch to zoom in (2.5x and up to 4x of that), drag down to close, and the
  // first time a "Double-tap to zoom" hint shows for a moment. Applied to the theme's lightbox (assets/gallery.js
  // exposes it as window.wtLightbox) and to the one gallery-lightbox-fix.js binds after a colour change.
  const phone = () => window.innerWidth < 750;
  const PSWP_OPTS = {
    paddingFn: () => (phone() ? { top: 56, bottom: 0, left: 0, right: 0 } : { top: 0, bottom: 0, left: 0, right: 0 }),
    initialZoomLevel: (z) => (phone() ? z.vFill : z.fit),
    secondaryZoomLevel: (z) => (phone() ? Math.min(1, z.vFill * 2.5) : Math.min(1, 3 * z.fit)),
    maxZoomLevel: (z) => (phone() ? Math.max(1, z.vFill * 4) : Math.max(1, 4 * z.fit)),
    doubleTapAction: 'zoom',
    closeOnVerticalDrag: true,
  };
  const decorate = (lb) => {
    if (!lb || lb._pdpm) return lb;
    lb._pdpm = true;
    Object.assign(lb.options, PSWP_OPTS);
    // PhotoSwipe only lets you drag down to close at "fit" size or smaller. The photo opens filling the screen's height,
    // a few px over "fit", so treat that opening size as "fit": drag down closes it, and the few px of side crop stay put.
    lb.on('zoomLevelsUpdate', ({ zoomLevels: z }) => {
      if (phone() && z.initial > z.fit) { z.fit = z.initial; z.min = Math.min(z.min, z.initial); }
    });
    const zoomedIn = (sl) => sl && sl.currZoomLevel > sl.zoomLevels.initial * 1.02;
    const zoomOut = (p, point) => { const sl = p.currSlide; if (sl) sl.zoomTo(sl.zoomLevels.initial, point, p.options.zoomAnimationDuration); };
    // While zoomed in, one tap goes back to the whole photo (instead of hiding the buttons)
    lb.on('tapAction', (e) => {
      const p = lb.pswp;
      if (!phone() || !p) return;
      e.preventDefault();
      if (zoomedIn(p.currSlide)) zoomOut(p, e.point);
    });
    // While zoomed in, dragging down from the photo's top edge also goes back to the whole photo
    let start = null;
    const yOf = (ev) => (ev?.touches?.[0] || ev?.changedTouches?.[0] || ev)?.clientY;
    lb.on('pointerDown', ({ originalEvent: ev }) => {
      const sl = lb.pswp?.currSlide;
      start = sl && zoomedIn(sl) ? { y: yOf(ev), atTop: sl.pan.y >= sl.bounds.min.y - 2 } : null;
    });
    lb.on('pointerUp', ({ originalEvent: ev }) => {
      const p = lb.pswp;
      if (!start || !p || p.gestures?.isMultitouch) { start = null; return; }
      const dy = (yOf(ev) ?? start.y) - start.y;
      if (start.atTop && dy > 60) zoomOut(p, { x: window.innerWidth / 2, y: window.innerHeight / 2 });
      start = null;
    });
    lb.on('uiRegister', () => {
      const pswp = lb.pswp;
      pswp.ui.registerElement({
        name: 'pdpm-cap', order: 9, isButton: false, appendTo: 'root', className: 'pdpm-pswp-cap',
        onInit: (el, p) => {
          const upd = () => {
            const img = p.currSlide?.data?.element?.querySelector('img');
            const t = phone() ? captionFor(img) : '';
            el.textContent = t; el.hidden = !t;
          };
          p.on('change', upd); upd();
        },
      });
      let shown = false;
      try { shown = localStorage.getItem('pdpm-zoom-hint') === '1'; } catch (e) {}
      if (!shown && phone()) {
        pswp.ui.registerElement({
          name: 'pdpm-hint', order: 10, isButton: false, appendTo: 'root', className: 'pdpm-pswp-hint',
          html: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1a1.5 1.5 0 0 1 3 0v1.5m0-.5a1.5 1.5 0 0 1 3 0V15c0 3.3-2.2 6-5.5 6-2.6 0-4-1.4-5.4-3.6L4.6 14.2a1.4 1.4 0 0 1 2.2-1.7L9 15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Double-tap to zoom</span>',
          onInit: (el, p) => {
            try { localStorage.setItem('pdpm-zoom-hint', '1'); } catch (e) {}
            const hide = () => el.classList.add('is-gone');
            setTimeout(hide, 2400);
            p.on('pointerDown', hide); p.on('zoomPanUpdate', () => { if (p.currSlide && p.currSlide.currZoomLevel > p.currSlide.zoomLevels.initial * 1.05) hide(); });
          },
        });
      }
    });
    return lb;
  };
  window.pdpmPswp = { decorate, captionFor };
  const decorateTheme = () => decorate(window.wtLightbox);
  // Before any tap reaches the theme's lightbox
  document.addEventListener('pointerdown', (e) => { if (e.target.closest('.photoswipe')) decorateTheme(); }, true);
  [0, 500, 1500, 3000].forEach((t) => setTimeout(decorateTheme, t));

  // One nudge per session so it's clear the photos slide
  let seen = false;
  try { seen = sessionStorage.getItem('pdpm-nudge') === '1'; } catch (e) {}
  if (!seen && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setTimeout(() => {
      const sw = galleryEl()?.gallerySwiper;
      if (!sw || sw.slides.length < 2) return;
      sw.translateTo(-46, 450);
      setTimeout(() => sw.slideTo(sw.activeIndex, 450), 600);
      try { sessionStorage.setItem('pdpm-nudge', '1'); } catch (e) {}
    }, 1200);
  }
})();

// ---------- 2026-10-20: one-colour products, Rebuy bundle in sync ----------
(() => {
  const root = document.querySelector('.pdpm');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const variantId = () => document.querySelector(`#product-form-${CSS.escape(sectionId)} input[name="id"]`)?.value || '';

  // Colour: a product with a single colour keeps the label and drops the row of one swatch. Limited colours have no
  // "Limited edition" tag (Cristóbal, 2026-10-17 and again 2026-10-20: shown like any other colour)
  const paintColour = () => {
    const body = root.querySelector('.wt-product__option__body--thumbs.pdpm-colour');
    if (!body) return;
    const inputs = [...body.querySelectorAll('input[type="radio"]')];
    const opt = body.closest('.wt-product__option');
    opt?.classList.toggle('pdpm-one-colour', inputs.length === 1);
    inputs.forEach((i) => { const l = i.nextElementSibling; if (l && l.tagName === 'LABEL' && !l.title) l.title = i.value; }); // name on hover
  };
  paintColour();

  // Rebuy bundle: its first row ("This item") started on the product's first variant (Maipo Burgundy / S) even when
  // the page opened on another one (ads, collection links, L by default); it follows the selected variant now
  const syncBundle = () => {
    const sel = document.querySelector('[data-rebuy-id] .rebuy-product-block.is-input-product select.rebuy-select');
    const id = variantId();
    if (!sel || !id || sel.value === id || ![...sel.options].some((o) => o.value === id)) return !!sel;
    sel.value = id;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };
  // Rebuy mounts the widget late and can re-render it once more: keep checking for 30 s (idempotent)
  let bundleTicks = 0;
  const bundleTimer = setInterval(() => { syncBundle(); if (++bundleTicks > 30) clearInterval(bundleTimer); }, 1000);

  const afterVariant = () => [50, 400, 1200].forEach((t) => setTimeout(() => { paintColour(); syncBundle(); }, t));
  root.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) afterVariant(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, afterVariant);
})();

// ---------- 2026-10-20: measurement (Microsoft Clarity custom events/tags + GTM dataLayer) ----------
// Clarity's own "Add to cart" smart event undercounts (Purple Dot and Rebuy add through their own buttons), so a cart
// add is counted when /cart/add answers OK, credited to the last button clicked: main, sticky, bundle or purpledot.
// Events: pdp_atc_<source>, pdp_size_select, pdp_size_finder_open, pdp_size_finder_apply, pdp_colour_change,
// pdp_sticky_shown, pdp_reviews_link, pdp_model_switch, pdp_gallery_zoom. Tags: product, vp_band, landing_variant,
// stock_state, size. GA4 gets them only once a GTM tag forwards these dataLayer events.
(() => {
  const root = document.querySelector('.pdpm');
  if (!root) return;
  const clarity = (...a) => { try { if (typeof window.clarity === 'function') window.clarity(...a); } catch (e) {} };
  const send = (name, data = {}) => {
    clarity('event', name);
    try { (window.dataLayer = window.dataLayer || []).push({ event: name, pdp_product: root.dataset.productHandle, ...data }); } catch (e) {}
  };
  const sectionId = root.dataset.sectionId;
  const w = window.innerWidth;
  clarity('set', 'product', root.dataset.productHandle || '');
  clarity('set', 'vp_band', w < 750 ? 'phone' : w < 900 ? '750-899' : w < 1200 ? '900-1199' : '1200+');
  clarity('set', 'landing_variant', new URLSearchParams(location.search).has('variant') ? 'yes' : 'no');
  const tagState = () => {
    const card = root.querySelector('.shipment-batch');
    // "Ships today" chip removed (2026-10-26): an in-stock variant now shows the delivery estimate instead
    const status = root.querySelector('.shipment-batch__status') || root.querySelector('delivery-estimate');
    const vis = (el) => !!el && el.getBoundingClientRect().height > 0 && getComputedStyle(el).display !== 'none';
    clarity('set', 'stock_state', vis(status) ? 'ships_today' : vis(card) ? 'next_shipment' : 'other');
    const size = root.querySelector('.wt-product__option__body--tiles input:checked')?.value;
    if (size) clarity('set', 'size', size);
  };
  setTimeout(tagState, 3000);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(tagState, 300));

  let source = null, at = 0;
  const mark = (s) => { source = s; at = Date.now(); };
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t.closest || !e.isTrusted) return; // the shopper's clicks only (not the L selected on landing)
    if (t.closest('sticky-buy-button .wt-product__sticky-buy__button')) mark('sticky');
    else if (t.closest('[data-rebuy-id] button')) mark('bundle');
    else if (t.closest('.x-pd-atc-form, [class*="purple-dot"], [id*="purple-dot"]')) mark('purpledot');
    else if (t.closest(`#product-form-${CSS.escape(sectionId)} [name="add"]`)) mark('main');
    // Size finder v3 sends its own pdp_size_finder_open (with pdp_height_saved): don't count the open twice
    if (t.closest('.pdpm .wt-product__information-popup')) { if (!document.querySelector('[data-sbf3]')) send('pdp_size_finder_open'); }
    else if (t.closest('[data-sbf] .sbf__foot button')) send('pdp_size_finder_apply');
    else if (t.closest('.pdpm-rating-link')) send('pdp_reviews_link');
    else if (t.closest('.pdpm-models a, .pdpm-compare a')) send('pdp_model_switch', { via: t.closest('.pdpm-compare') ? 'compare' : 'buttons' });
    else if (t.closest('.pdpm gallery-section .photoswipe, .pdpm gallery-section .wt-masonry__slide, .pdpm gallery-section .swiper-slide')) send('pdp_gallery_zoom');
  }, true);
  root.addEventListener('change', (e) => {
    const i = e.target;
    // One event per choice: a click on a size label also clicks its radio, so sizes are counted on "change";
    // the L selected on landing is not the shopper's choice (untrusted)
    if (e.isTrusted && i.matches?.('.wt-product__option__body--tiles input[type="radio"]')) send('pdp_size_select', { via: 'pill', size: i.value });
    if (i.matches?.('.wt-product__option__body--thumbs.pdpm-colour input[type="radio"]')) send('pdp_colour_change', { limited: i.dataset.isLimitedEdition === 'true' });
  });

  // The size finder's button clicks Add to cart for the shopper (untrusted click): count it as size_finder
  document.addEventListener('sizefinder:select', () => mark('size_finder'));
  const isCartAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(url || '');
  const isFinderExt = (init) => { try { const h = init && init.headers; return !!h && (typeof h.get === 'function' ? h.get('X-SBF3-Ext') : h['X-SBF3-Ext']) === '1'; } catch (e) { return false; } };
  const counted = () => {
    const s = Date.now() - at < 10000 && source ? source : 'other';
    send(`pdp_atc_${s}`, { source: s });
    clarity('upgrade', 'add_to_cart');
    source = null;
  };
  const origFetch = window.fetch;
  if (origFetch && !origFetch._pdpm) {
    const wrapped = function (input, init) {
      const url = typeof input === 'string' ? input : input?.url;
      const p = origFetch.apply(this, arguments);
      if (isCartAdd(url) && !isFinderExt(init)) p.then((r) => { if (r.ok) counted(); }).catch(() => {});
      return p;
    };
    wrapped._pdpm = true;
    window.fetch = wrapped;
  }
  const origOpen = XMLHttpRequest.prototype.open;
  if (!origOpen._pdpm) {
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartAdd(String(url))) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) counted(); });
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.open._pdpm = true;
  }

  const dock = document.querySelector('sticky-buy-button');
  if (dock) {
    const mo = new MutationObserver(() => {
      if (dock.classList.contains('wt-product__sticky-buy--show')) { send('pdp_sticky_shown'); mo.disconnect(); }
    });
    mo.observe(dock, { attributes: true, attributeFilter: ['class'] });
  }
})();

// ---------- 2026-10-20: reviews before the customer videos (SWYTCH) ----------
// Clarity desktop: 44% of the time of whoever scrolls goes to the Judge.me reviews, which came after the videos,
// the press logos and the testimonials (55–75% of the page). They move up to right after the press logos.
// Done here and not in templates/product.swytch.json so edits made in the theme editor are never overwritten.
(() => {
  const root = document.querySelector('.pdpm[data-reviews-up]');
  if (!root) return;
  const sections = [...document.querySelectorAll('.shopify-section')];
  const reviews = document.getElementById('judgeme_product_reviews')?.closest('.shopify-section');
  const videos = sections.find((s) => /testimonial_video_reels/.test(s.id));
  if (!reviews || !videos || reviews.compareDocumentPosition(videos) & Node.DOCUMENT_POSITION_FOLLOWING) return;
  // The rich text right above the videos is their heading ("Real Stories, Real Results"): keep it with them
  const prev = videos.previousElementSibling;
  const anchor = prev && /rich_text/.test(prev.id) ? prev : videos;
  anchor.before(reviews);
})();

// ---------- 2026-10-20: "Compare models" table (snippets/pdpm-models.liquid) ----------
(() => {
  const root = document.querySelector('.pdpm');
  if (!root) return;
  document.addEventListener('click', (e) => {
    const open = e.target.closest?.('[data-pdpm-compare]');
    if (open) {
      const dlg = document.getElementById(open.dataset.pdpmCompare);
      if (!dlg) return;
      // The dialog lives inside the product info column; at the end of <body> no parent can clip or stack over it
      if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.body.classList.add('pdpm-compare-open');
      try { if (typeof window.clarity === 'function') window.clarity('event', 'pdp_compare_open'); (window.dataLayer = window.dataLayer || []).push({ event: 'pdp_compare_open', pdp_product: root.dataset.productHandle }); } catch (err) {}
      return;
    }
    const dlg = e.target.closest?.('dialog.pdpm-compare');
    if (!dlg) return;
    // Close on the X, on "Keep this one", or on a click on the backdrop (the dialog itself, outside its box)
    if (e.target.closest('[data-pdpm-compare-close]') || e.target === dlg) dlg.close();
  });
  document.addEventListener('close', (e) => { if (e.target.matches?.('dialog.pdpm-compare')) document.body.classList.remove('pdpm-compare-open'); }, true);
})();
